import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import IMotiveException from 'types/company/payroll/IMotiveException';

export const getMotiveExceptionsRequest = async (companyId: number): Promise<IMotiveException[]> => {
  const response: AxiosResponse<IMotiveException[]> = await getApi().get(`Company/${companyId}/MotiveExceptions`);
  return response.data;
};

export const addMotiveExceptionRequest = async (props: {
  companyId: number;
  motiveException: IMotiveException;
}): Promise<number> => {
  const { companyId, motiveException } = props;
  const response: AxiosResponse<number> = await getApi().post(`Company/${companyId}/MotiveExceptions`, motiveException);
  return response.data;
};

export const updateMotiveExceptionRequest = async (props: {
  companyId: number;
  motiveException: IMotiveException;
}): Promise<void> => {
  const { companyId, motiveException } = props;
  await getApi().put(`Company/${companyId}/MotiveExceptions/${motiveException.id}`, motiveException);
};

export const deleteMotiveExceptionRequest = async (props: { companyId: number; id: number }): Promise<void> => {
  const { companyId, id } = props;
  await getApi().delete(`Company/${companyId}/MotiveExceptions/${id}`);
};
